
import { defineComponent, ref, watch, inject } from "vue";
import * as EventTypes from "@/shared/eventTypes";
import { useConversation } from "@/composables/conversation";
import Launcher from "@/components/Launcher.vue";
import Messenger from "@/components/Messenger.vue";
import { useChatConnection } from "@/composables/chatConnection";
import { useWidgetConfig } from "@/composables/widgetConfig";
import { useI18n } from "vue-i18n";
import { setupI18n, SUPPORTED_LOCALES } from "@/i18n";

export default defineComponent({
  name: "ChatWidget",
  components: { Messenger, Launcher },
  props: {
    msg: String,
  },
  setup() {
    const { isReady, isWidgetOpen } = useConversation();
    const { configuration } = useWidgetConfig();
    const { locale } = useI18n();
    const formkitConfig = inject(Symbol.for("FormKitConfig"));

    watch(
      () => configuration.value?.locale,
      () => {
        if (configuration.value?.locale) {
          if (SUPPORTED_LOCALES.includes(configuration.value.locale)) {
            console.debug("Setting locale", configuration.value.locale);
            locale.value = configuration.value.locale;

            if (configuration.value.locale === "no") {
              (formkitConfig as any).locale = "nb";
            }
          } else {
            console.warn("Locale not supported", configuration.value?.locale);
          }
        }
      }
    );

    const delayedIsWidgetOpen = ref(isWidgetOpen.value);

    const { ws, status, notifyCloseWidget, notifyOpenWidget } =
      useChatConnection();

    watch(
      () => status.value,
      () => {
        console.log("connection status:", status.value);
      },
      {
        immediate: true,
      }
    );

    watch(
      () => isWidgetOpen.value,
      () => {
        // Shim will resize the iframe container depending on open/close state.
        // We will add a slight delay, effectively waiting until the shrinking/growing has completed before transitioning (keeps the transitions looking nice).

        if (isWidgetOpen.value) {
          window.parent.postMessage(
            {
              type: EventTypes.OPEN_WIDGET,
            },
            "*"
          );
          setTimeout(() => {
            delayedIsWidgetOpen.value = true;
          }, 100);
        } else {
          delayedIsWidgetOpen.value = false;
          setTimeout(() => {
            window.parent.postMessage(
              {
                type: EventTypes.CLOSE_WIDGET,
              },
              "*"
            );
          }, 100);
        }
      },
      {
        immediate: true,
      }
    );

    return {
      isWidgetOpen,
      isReady,
      notifyCloseWidget,
      notifyOpenWidget,
      delayedIsWidgetOpen,
    };
  },
});
